import clsx from "clsx";

import { Button } from "@shared/buttons/button";

import { type Platform } from "../configure-platforms/platforms/constants";
import { usePlatformsMetadata } from "../configure-platforms/platforms/metadata";

export const InfoPanel = ({
  label,
  children,
  className,
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={clsx(
      "border border-gray-0 rounded-lg bg-cosmic-5 p-6 w-full",
      className,
    )}
  >
    <div className="flex items-center gap-2 pb-4">
      <div className="w-[18px] h-[18px] bg-cosmic rounded-full border border-black flex justify-center items-center">
        <i className="fa-solid fa-question fa-xs text-[#ffffff]" />
      </div>
      <div>
        <div className="text-lg font-semibold">{label}</div>
      </div>
    </div>
    {children}
  </div>
);

export const ReadDocumentationButton = ({
  docUrl,
  label = "Read the documentation",
}: {
  docUrl: string;
  label?: string;
}) => (
  <Button
    className="px-4 py-1.5"
    variant="secondary"
    onClick={() => {
      window.open(docUrl, "_blank");
    }}
  >
    <i className="fa-sharp fa-regular fa-file mr-2" />
    <span className="text-interstellar no-underline uppercase text-xs font-semibold leading-tight tracking-tight">
      {label}
    </span>
  </Button>
);

export const InfoPanelForOfficialDocumentation = ({
  label = "Need more guidance?",
  platform,
  docUrl,
  className,
}: {
  label?: string;
  platform: Platform;
  docUrl: string;
  className?: string;
}) => {
  const { getTitleForPlatform } = usePlatformsMetadata();
  return (
    <InfoPanel label={label} className={clsx("mt-4", className)}>
      <a
        href={docUrl}
        target="_blank"
        className="border border-gray-0 bg-white px-4 py-[6px] inline-flex items-center gap-2 rounded-2xl no-underline text-black uppercase"
        rel="noreferrer"
      >
        Read {getTitleForPlatform(platform)}’s official documentation
      </a>
    </InfoPanel>
  );
};
